var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import displayToast from '../../Util/Toast';
import { fetchProposalDetails, generateHtmlTemplate, newsletterPostAction } from '../../Util/ApiService';
import Loader from '../Loader/Loader';
import NewsletterModalProposalCard from './ProposalCard';
import SendConfirmationModal from './SendConfirmationModal';
import { runNewsletterScriptsFromHtml } from '../../Util/data';
// EmailCategory::NEWSLETTER
const DEFAULT_EMAIL_CATEGORY_CODE = 'NW';
const RequiredMark = () => (React.createElement("span", { className: "text-red-600", "aria-hidden": "true" },
    ' ',
    "*"));
const AddNewsletterModal = ({ addNewsletterTemplateUrl, createBatchUrl, editNewsletterTemplateUrl, fetchNumberOfRecipientsUrl, generateHtmlUrl, guideUrl, newsletterTemplatesListUrl, previewBatchUrl, proposalDetailsUri, sites, testEmailUrl, userId, userStatuses, userTypes, userRoles, newsletterFormats, emailCategories, onSaveSuccess, newsletterContent, type }) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const proposalCardRef = useRef(null);
    const debounceRef = useRef(null);
    const requestIdRef = useRef(0);
    const previewElementRef = useRef(null);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [fromEmailAddress, setFromEmailAddress] = useState('info@angelinvestmentnetwork.co.uk');
    const [replyToEmailAddress, setReplyToEmailAddress] = useState(null);
    const [fromName, setFromName] = useState('');
    const [proposalId, setProposalId] = useState(null);
    const [proposalDetails, setProposalDetails] = useState(null);
    const [displayProposalDetails, setProposalDetailsDisplay] = useState(false);
    const [isFetchingProposal, setIsFetchingProposal] = useState(false);
    const [template, setTemplate] = useState({
        subject: '',
        title: '',
        content: '',
        newsletterFormatCode: '',
        emailCategoryCode: DEFAULT_EMAIL_CATEGORY_CODE,
        proposalId: null
    });
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [checkedUserStatuses, setCheckedUserStatuses] = useState(userStatuses && userStatuses.length ? [userStatuses[0]] : []);
    const [checkedUserTypes, setCheckedUserTypes] = useState(userTypes && userTypes.length ? userTypes : []);
    const [checkedUserRoles, setCheckedUserRoles] = useState([]);
    const [selectedSiteCode, setSelectedSiteCode] = useState(null);
    const [recipientIds, setRecipientIds] = useState([]);
    const [isSending, setIsSending] = useState(false);
    const [isSimulating, setSimulating] = useState(false);
    const [isSendingTestEmail, setSendingTestEmail] = useState(false);
    const [simulatedRecipients, setSimulatedRecipients] = useState(null);
    const [sendConfirmation, setSendConfirmation] = useState(null);
    const [isPreparingSend, setIsPreparingSend] = useState(false);
    const [generatingHtml, setGeneratingHtml] = useState(false);
    const [sameAsSubject, setSameAsSubject] = useState(false);
    const [scheduledDate, setScheduledDate] = useState('');
    const [scheduledHour, setScheduledHour] = useState('12');
    const [scheduledMinute, setScheduledMinute] = useState('00');
    const [sendImmediately, setSendImmediately] = useState(true);
    const [savedTemplateId, setSavedTemplateId] = useState((newsletterContent === null || newsletterContent === void 0 ? void 0 : newsletterContent.newsletterTemplateId) || null);
    const [fromUserRegisterDate, setFromUserRegisterDate] = useState(null);
    const [toUserRegisterDate, setToUserRegisterDate] = useState(null);
    const handleTemplateChange = (field, value) => {
        setTemplate((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
        setHasUnsavedChanges(true);
        if (field === 'subject' &&
            document.getElementById('sameAsSubject').checked) {
            setTemplate((prev) => (Object.assign(Object.assign({}, prev), { title: value })));
        }
    };
    const generateHtml = () => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        setGeneratingHtml(true);
        if (!proposalId) {
            displayToast('Please enter a valid Proposal ID', 'error');
            setGeneratingHtml(false);
            return;
        }
        try {
            const res = yield generateHtmlTemplate(generateHtmlUrl.replace('PROPOSAL_ID_PLACEHOLDER', proposalId.toString()));
            // Remove any previously generated preview so pressing the button
            // again replaces the block instead of appending a new one.
            if (previewElementRef.current) {
                previewElementRef.current.remove();
                previewElementRef.current = null;
            }
            const previewElement = document.createElement('div');
            previewElement.innerHTML = res;
            (_d = proposalCardRef === null || proposalCardRef === void 0 ? void 0 : proposalCardRef.current) === null || _d === void 0 ? void 0 : _d.insertAdjacentElement('afterend', previewElement);
            previewElementRef.current = previewElement;
            // Execute scripts in the generated HTML
            runNewsletterScriptsFromHtml(res);
            // eslint-disable-next-line no-undef
            const textAreaElement = document.getElementById('html-preview');
            if (textAreaElement) {
                textAreaElement.classList.remove('hidden');
            }
            setGeneratingHtml(false);
        }
        catch (error) {
            console.error('Error generating HTML template:', error);
            displayToast('Failed to generate HTML template', 'error');
            return setGeneratingHtml(false);
        }
    });
    const closeModal = () => {
        const container = document.getElementById('modal-container');
        if (container) {
            container.innerHTML = '';
            return;
        }
        const modalWrapper = document.querySelector('.modal-wrapper');
        if (modalWrapper) {
            modalWrapper.classList.add('hidden');
        }
    };
    const hideModal = () => {
        // eslint-disable-next-line no-undef
        if (hasUnsavedChanges &&
            !confirm('You have unsaved changes. Close anyway?'))
            return;
        closeModal();
    };
    const handleSiteChange = (site) => {
        setFromEmailAddress(site.emailAddress);
        setSelectedSiteCode(site.siteId);
    };
    const handleReplyToEmailChange = (event) => {
        setReplyToEmailAddress(event.target.value);
    };
    const handleSameAsSubjectChange = (event) => {
        // eslint-disable-next-line no-undef
        const titleInput = document.getElementById('title');
        // eslint-disable-next-line no-undef
        const subjectInput = document.getElementById('subject');
        if (event.target.checked) {
            titleInput.value = subjectInput.value;
            titleInput.disabled = true;
            setTemplate((prev) => (Object.assign(Object.assign({}, prev), { title: prev.subject })));
            setSameAsSubject(true);
        }
        else {
            titleInput.value = '';
            titleInput.disabled = false;
            setSameAsSubject(false);
        }
    };
    const fetchProposal = () => __awaiter(void 0, void 0, void 0, function* () {
        var _e, _f;
        const requestId = ++requestIdRef.current;
        if (!proposalId) {
            setIsFetchingProposal(false);
            return;
        }
        setIsFetchingProposal(true);
        const url = proposalDetailsUri.replace('PROPOSAL_ID_PLACEHOLDER', proposalId.toString());
        try {
            const proposal = yield fetchProposalDetails(url);
            if (requestId !== requestIdRef.current) {
                return;
            }
            setProposalDetails(proposal);
            setProposalDetailsDisplay(true);
            displayToast('Proposal details fetched successfully', 'success');
        }
        catch (error) {
            if (requestId !== requestIdRef.current) {
                return;
            }
            console.error('Error fetching proposal details:', error);
            setProposalDetails(null);
            setProposalDetailsDisplay(false);
            if (((_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.status) === 404) {
                displayToast('No proposal found with this ID', 'error');
            }
            else if (((_f = error === null || error === void 0 ? void 0 : error.response) === null || _f === void 0 ? void 0 : _f.status) === 403) {
                displayToast('This proposal is not active', 'error');
            }
            else {
                displayToast('Failed to fetch proposal details', 'error');
            }
        }
        finally {
            if (requestId === requestIdRef.current) {
                setIsFetchingProposal(false);
            }
        }
    });
    const handleFindProposal = () => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            debounceRef.current = null;
        }
        fetchProposal();
    };
    const handleSave = (closeAfterSave = false, isACopy = false) => __awaiter(void 0, void 0, void 0, function* () {
        if (template.subject.length === 0) {
            return displayToast('Subject is required', 'error');
        }
        if (template.title.length === 0) {
            return displayToast('Title is required', 'error');
        }
        if (template.content.length === 0) {
            return displayToast('Content is required', 'error');
        }
        if (template.newsletterFormatCode.length === 0) {
            return displayToast('Newsletter format is required', 'error');
        }
        if (template.emailCategoryCode.length === 0) {
            return displayToast('Email category is required', 'error');
        }
        if (!hasUnsavedChanges && !isACopy)
            return;
        setIsSaving(true);
        const isEditing = savedTemplateId !== null && !isACopy;
        const url = isEditing ? editNewsletterTemplateUrl : addNewsletterTemplateUrl;
        const params = isEditing
            ? {
                newsletterTemplateId: savedTemplateId,
                subject: template.subject,
                title: template.title,
                content: template.content,
                newsletterFormat: template.newsletterFormatCode,
                emailCategory: template.emailCategoryCode,
                proposal: template.proposalId
            }
            : {
                subject: template.subject,
                title: template.title,
                content: template.content,
                newsletterFormat: template.newsletterFormatCode,
                emailCategory: template.emailCategoryCode,
                proposal: template.proposalId
            };
        try {
            const res = yield newsletterPostAction(url, params);
            if (isEditing) {
                displayToast('Template updated successfully', 'success');
                setHasUnsavedChanges(false);
                if (onSaveSuccess) {
                    onSaveSuccess();
                }
                if (closeAfterSave) {
                    closeModal();
                }
            }
            else if (res) {
                displayToast(isACopy ? 'Template copy saved successfully' : 'Template saved successfully', 'success');
                setHasUnsavedChanges(false);
                if (res.newsletterTemplateId) {
                    setSavedTemplateId(res.newsletterTemplateId);
                }
                if (isACopy) {
                    closeModal();
                    const currentPath = window.location.pathname;
                    if (currentPath === newsletterTemplatesListUrl) {
                        if (onSaveSuccess) {
                            onSaveSuccess();
                        }
                    }
                }
                else if (closeAfterSave) {
                    // eslint-disable-next-line no-undef
                    location.reload();
                }
            }
            if (closeAfterSave) {
                hideModal();
            }
        }
        catch (error) {
            displayToast('Title must be unique. A template with this title already exists.', 'error');
        }
        finally {
            setIsSaving(false);
        }
    });
    const handleDiscard = () => {
        // eslint-disable-next-line no-undef
        if (hasUnsavedChanges && !confirm('Discard unsaved changes?'))
            return;
        setTemplate({
            subject: '',
            title: '',
            content: '',
            newsletterFormatCode: '',
            emailCategoryCode: DEFAULT_EMAIL_CATEGORY_CODE,
            proposalId: null
        });
        setHasUnsavedChanges(false);
        hideModal();
    };
    const handleUserStatusChange = (e) => {
        const value = e.target.value;
        const isChecked = e.target.checked;
        setCheckedUserStatuses((prev) => {
            return isChecked ? [...prev, value] : prev.filter((v) => v !== value);
        });
    };
    const handleUserTypeChange = (e) => {
        const value = e.target.value;
        const isChecked = e.target.checked;
        setCheckedUserTypes((prev) => {
            return isChecked ? [...prev, value] : prev.filter((v) => v !== value);
        });
    };
    const handleUserRoleChange = (e) => {
        const value = e.target.value;
        const isChecked = e.target.checked;
        setCheckedUserRoles((prev) => {
            return isChecked ? [...prev, value] : prev.filter((v) => v !== value);
        });
    };
    const handleRecipientIdUpdate = (e) => {
        const splitItems = e.target.value
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item !== '');
        return setRecipientIds(splitItems);
    };
    const fetchRecipientCounts = (ids) => newsletterPostAction(fetchNumberOfRecipientsUrl, {
        newsletterTemplate: savedTemplateId !== null && savedTemplateId !== void 0 ? savedTemplateId : newsletterContent === null || newsletterContent === void 0 ? void 0 : newsletterContent.newsletterTemplateId,
        site: selectedSiteCode,
        userStatusCodes: checkedUserStatuses,
        userTypeCodes: checkedUserTypes,
        userRoleCodes: checkedUserRoles,
        recipientIds: ids,
        fromUserRegisterDate: fromUserRegisterDate,
        toUserRegisterDate: toUserRegisterDate
    });
    const audienceError = () => {
        if (!checkedUserStatuses.length) {
            return 'Select at least one user status';
        }
        if (!checkedUserTypes.length) {
            return 'Select at least one user type';
        }
        return null;
    };
    const simulateUsers = () => __awaiter(void 0, void 0, void 0, function* () {
        var _g;
        if (!selectedSiteCode) {
            return displayToast('Please select a network', 'error');
        }
        if (!savedTemplateId) {
            return displayToast('Save the template before simulating the number of users', 'error');
        }
        const audienceErrorMessage = audienceError();
        if (audienceErrorMessage) {
            return displayToast(audienceErrorMessage, 'error');
        }
        setSimulating(true);
        try {
            setSimulatedRecipients(yield fetchRecipientCounts(recipientIds));
        }
        catch (error) {
            console.error(error);
            displayToast(((_g = error === null || error === void 0 ? void 0 : error.response) === null || _g === void 0 ? void 0 : _g.data) || 'Could not count the recipients', 'error');
        }
        finally {
            setSimulating(false);
        }
    });
    const sendTestEmail = () => __awaiter(void 0, void 0, void 0, function* () {
        var _h;
        if (!selectedSiteCode) {
            return displayToast('Please select a network', 'error');
        }
        if (!savedTemplateId) {
            return displayToast('Save the template before sending a test email', 'error');
        }
        if (!fromEmailAddress.trim()) {
            return displayToast('From email address is required', 'error');
        }
        setSendingTestEmail(true);
        try {
            const response = yield newsletterPostAction(testEmailUrl, {
                newsletterTemplate: savedTemplateId,
                site: selectedSiteCode,
                fromEmailAddress: fromEmailAddress,
                replyToEmailAddress: replyToEmailAddress,
                recipientIds: recipientIds,
                fromName: fromName
            });
            if (response) {
                setSendingTestEmail(false);
                displayToast(response, 'success');
            }
        }
        catch (error) {
            console.error(error);
            setSendingTestEmail(false);
            displayToast((_h = error === null || error === void 0 ? void 0 : error.response) === null || _h === void 0 ? void 0 : _h.data, 'error');
        }
    });
    const requestSendConfirmation = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedSiteCode) {
            return displayToast('Please select a network', 'error');
        }
        if (!savedTemplateId) {
            return displayToast('Save the template before sending it', 'error');
        }
        if (recipientIds.length) {
            return displayToast('Recipient IDs only apply to Simulate and Send test email. Clear the field to send or schedule the mailout.', 'error');
        }
        if (!fromEmailAddress.trim()) {
            return displayToast('From email address is required', 'error');
        }
        const audienceErrorMessage = audienceError();
        if (audienceErrorMessage) {
            return displayToast(audienceErrorMessage, 'error');
        }
        let scheduledSendAt = null;
        if (!sendImmediately) {
            if (!scheduledDate) {
                return displayToast('Please select a scheduled send date', 'error');
            }
            scheduledSendAt = `${scheduledDate}T${scheduledHour.padStart(2, '0')}:${scheduledMinute.padStart(2, '0')}:00Z`;
            const minScheduledTime = new Date(Date.now() + 15 * 60000);
            if (new Date(scheduledSendAt) < minScheduledTime) {
                return displayToast('Scheduled time must be at least 15 minutes in the future (GMT)', 'error');
            }
        }
        setIsPreparingSend(true);
        try {
            setSendConfirmation({
                recipients: yield fetchRecipientCounts([]),
                scheduledSendAt
            });
        }
        catch (error) {
            console.error(error);
            displayToast('Could not count the recipients, please try again', 'error');
        }
        finally {
            setIsPreparingSend(false);
        }
    });
    const createBatch = (scheduledSendAt) => __awaiter(void 0, void 0, void 0, function* () {
        var _j;
        setIsSending(true);
        try {
            yield newsletterPostAction(createBatchUrl, {
                newsletterTemplate: savedTemplateId,
                site: selectedSiteCode,
                fromEmailAddress: fromEmailAddress,
                replyToEmailAddress: replyToEmailAddress,
                userStatusCodes: checkedUserStatuses,
                userTypeCodes: checkedUserTypes,
                userRoleCodes: checkedUserRoles,
                fromName: fromName,
                recipientIds: recipientIds,
                scheduledSendAt: scheduledSendAt,
                fromUserRegisterDate: fromUserRegisterDate,
                toUserRegisterDate: toUserRegisterDate
            });
            setIsSending(false);
            setSendConfirmation(null);
            closeModal();
            const message = scheduledSendAt
                ? 'Mailout scheduled successfully'
                : 'Mailout queued. Sending starts within 15 minutes.';
            return displayToast(message, 'success');
        }
        catch (error) {
            console.error(error);
            setIsSending(false);
            setSendConfirmation(null);
            const errorMessage = ((_j = error === null || error === void 0 ? void 0 : error.response) === null || _j === void 0 ? void 0 : _j.data) || (error === null || error === void 0 ? void 0 : error.message) || 'Failed to create newsletter batch';
            displayToast(errorMessage, 'error');
        }
    });
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (hasUnsavedChanges) {
                e.preventDefault();
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [hasUnsavedChanges]);
    useEffect(() => {
        if (proposalId === null) {
            return;
        }
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            fetchProposal();
        }, 1000);
        return () => {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
                debounceRef.current = null;
            }
        };
    }, [proposalId]);
    useEffect(() => {
        if (newsletterContent) {
            setTemplate({
                subject: newsletterContent.subject || '',
                title: newsletterContent.title || '',
                content: newsletterContent.content || '',
                newsletterFormatCode: newsletterContent.newsletterFormatCode || '',
                emailCategoryCode: newsletterContent.emailCategoryCode || '',
                proposalId: newsletterContent.proposalId
                    ? newsletterContent.proposalId
                    : null
            });
            if (newsletterContent.title === newsletterContent.subject) {
                setSameAsSubject(true);
            }
            if (newsletterContent.proposalId) {
                setProposalId(newsletterContent.proposalId);
            }
        }
    }, [newsletterContent]);
    return (React.createElement("div", { tabIndex: -1, className: "overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-full md:h-screen justify-center items-center flex bg-black/90 md:pb-12 pb-14", role: "dialog" },
        React.createElement("div", { className: "bg-white rounded-2xl py-6 md:w-1/2 xl:w-2/5 w-11/12 max-w-full h-auto m-auto md:mt-12 mt-14 flex flex-col gap-4" },
            React.createElement("div", { role: "tablist", className: "flex gap-1 items-center" },
                React.createElement("button", { role: "tab", "aria-selected": "true", className: `border-b-2 ${activeTabIndex === 0
                        ? 'border-blue-600 hover:text-blue-600 text-blue-600'
                        : 'border-transparent text-gray-800 hover:text-gray-700'} px-4 py-2 text-lg font-semibold transition-colors`, onClick: () => {
                        return setActiveTabIndex(0);
                    } }, "Template Details"),
                React.createElement("button", { role: "tab", "aria-selected": "false", className: `border-b-2 ${activeTabIndex === 1
                        ? 'border-blue-600 hover:text-blue-600 text-blue-600'
                        : 'border-transparent text-gray-800 hover:text-gray-700'} px-4 py-2 text-lg font-semibold transition-colors`, onClick: () => {
                        return setActiveTabIndex(1);
                    } }, "Email Details"),
                React.createElement("a", { href: guideUrl, target: "_blank", rel: "noreferrer", className: "ml-auto mr-6 px-2 text-sm text-blue-600 underline whitespace-nowrap" }, "How to use this screen")),
            React.createElement("div", { role: "tabpanel", id: "template-details", className: `w-full py-2 md:px-6 px-4 flex flex-col items-start gap-6 ${activeTabIndex !== 0 ? 'hidden' : ''}` },
                React.createElement("div", { className: "w-full flex flex-col gap-2" },
                    React.createElement("label", { htmlFor: "subject", className: "font-semibold text-gray-800 text-lg" },
                        "Subject",
                        React.createElement(RequiredMark, null)),
                    React.createElement("input", { type: "text", id: "subject", required: true, value: template.subject, onChange: (e) => {
                            return handleTemplateChange('subject', e.target.value);
                        }, className: "text-left p-3 border w-full border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal" })),
                React.createElement("div", { className: "w-full flex flex-col gap-2" },
                    React.createElement("label", { htmlFor: "title", className: "font-semibold text-gray-800 text-lg" },
                        "Title",
                        React.createElement(RequiredMark, null)),
                    React.createElement("label", { htmlFor: "sameAsSubject", className: "text-gray-700 text-base inline-flex items-center gap-2" },
                        React.createElement("input", { onChange: handleSameAsSubjectChange, id: "sameAsSubject", type: "checkbox", checked: sameAsSubject, className: "bg-custom-checkbox bg-size-[100%_100%] bg-center bg-no-repeat shrink-0 appearance-none cursor-pointer w-4 h-4 rounded-sm border border-gray-400 bg-white checked:bg-blue-600 checked:border-transparent focus:outline-hidden" }),
                        "Same as Subject"),
                    React.createElement("input", { type: "text", id: "title", required: true, value: template.title, onChange: (e) => {
                            return handleTemplateChange('title', e.target.value);
                        }, className: "text-left p-3 border w-full border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal disabled:bg-gray-200" })),
                React.createElement("div", { className: "w-full flex flex-col gap-2" },
                    React.createElement("label", { htmlFor: "newsletterFormat", className: "font-semibold text-gray-800 text-lg" },
                        "Newsletter Format",
                        React.createElement(RequiredMark, null)),
                    React.createElement("div", { className: "w-full grid grid-cols-2 gap-4" }, newsletterFormats.map((newsletterFormat) => (React.createElement("label", { key: newsletterFormat.code, className: "flex items-center gap-3 cursor-pointer" },
                        React.createElement("input", { type: "radio", name: "newsletterFormat", required: true, value: newsletterFormat.code, checked: template.newsletterFormatCode === newsletterFormat.code, onChange: (e) => {
                                return handleTemplateChange('newsletterFormatCode', e.target.value);
                            }, className: "h-4 w-4" }),
                        React.createElement("span", { className: "text-gray-700" }, newsletterFormat.name)))))),
                React.createElement("div", { className: "w-full flex flex-col gap-2" },
                    React.createElement("label", { htmlFor: "emailCategory", className: "font-semibold text-gray-800 text-lg" },
                        "Email Category",
                        React.createElement(RequiredMark, null)),
                    React.createElement("p", { className: "text-gray-600 text-sm" }, "Recipients are the people subscribed to this category, and it is the category they can unsubscribe from."),
                    React.createElement("select", { id: "emailCategory", required: true, value: template.emailCategoryCode, onChange: (e) => {
                            return handleTemplateChange('emailCategoryCode', e.target.value);
                        }, className: "text-left p-3 border w-full border-gray-300 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal" }, emailCategories.map((emailCategory) => (React.createElement("option", { key: emailCategory.code, value: emailCategory.code }, emailCategory.name))))),
                React.createElement("div", { className: "w-full flex flex-col gap-2" },
                    React.createElement("label", { htmlFor: "content", className: "font-semibold text-gray-800 text-lg" },
                        "Content",
                        React.createElement(RequiredMark, null)),
                    React.createElement("textarea", { id: "content", required: true, rows: 4, onChange: (e) => {
                            return handleTemplateChange('content', e.target.value);
                        }, value: template.content, className: "text-left p-3 border w-full border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal" })),
                proposalDetails && displayProposalDetails ? (React.createElement(NewsletterModalProposalCard, { proposalRef: proposalCardRef, proposalUri: proposalDetails.proposalUri, proposalTitle: proposalDetails.title, generating: generatingHtml, generateHtml: generateHtml, removeProposalCard: () => {
                        if (previewElementRef.current) {
                            previewElementRef.current.remove();
                            previewElementRef.current = null;
                        }
                        handleTemplateChange('proposalId', null);
                        setProposalId(null);
                        setProposalDetails(null);
                        setProposalDetailsDisplay(false);
                    } })) : (React.createElement("div", { className: "w-full flex flex-col gap-2" },
                    React.createElement("label", { htmlFor: "proposalId", className: "font-semibold text-gray-800 text-lg" }, "Proposal ID"),
                    React.createElement("div", { className: "w-full flex items-center" },
                        React.createElement("input", { onChange: (event) => {
                                handleTemplateChange('proposalId', event.target.value);
                                return setProposalId(event.target.value
                                    ? parseInt(event.target.value, 10)
                                    : null);
                            }, type: "text", id: "proposalId", className: "text-left p-3 border w-2/3 border-gray-300 placeholder-gray-200 rounded-sm rounded-r-none focus:outline-hidden focus:border-blue-500 font-normal" }),
                        React.createElement("button", { onClick: handleFindProposal, type: "button", className: "\n                  p-3\n                  w-1/3\n                  bg-blue-600\n                  border\n                  border-blue-600\n                  text-white\n                  font-semibold\n                  text-base\n                  rounded-md\n                  rounded-l-none\n                ", disabled: isFetchingProposal }, isFetchingProposal ? React.createElement(Loader, { title: "Fetching..." }) : 'Find')))),
                React.createElement("textarea", { id: "html-preview", className: "hidden min-h-48 text-left p-3 border w-full border-gray-300 placeholder-gray-200 mt-2 rounded-sm focus:outline-hidden focus:border-blue-500" }),
                React.createElement("hr", { className: "w-full border-gray-400" }),
                React.createElement("div", { className: "w-full flex items-center sm:flex-row flex-col justify-between gap-2 sm:items-[unset] items-start" },
                    React.createElement("div", { className: "sm:w-auto w-full flex flex-wrap items-center gap-2" },
                        React.createElement("button", { type: "button", onClick: () => {
                                return handleSave(false, true);
                            }, disabled: type === 'add' || isSaving, className: `px-4 py-2 md:w-auto w-full font-semibold text-base rounded-md ${type === 'add'
                                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                : 'bg-green-400 text-gray-800'}` }, isSaving ? (React.createElement(Loader, { title: "Saving..." })) : ('Save a copy & close')),
                        React.createElement("button", { type: "button", onClick: handleDiscard, className: "px-4 py-2 md:w-auto w-full bg-red-400 text-white font-semibold text-base rounded-md" }, "Discard")),
                    React.createElement("div", { className: "sm:w-auto w-full flex flex-wrap items-center gap-2" },
                        React.createElement("button", { type: "button", onClick: () => {
                                return handleSave(true);
                            }, disabled: !hasUnsavedChanges || isSaving, className: `px-4 py-2 md:w-auto w-full font-semibold text-base rounded-md ${!hasUnsavedChanges
                                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                : 'bg-gray-200 text-gray-800'}` }, "Save & close"),
                        React.createElement("button", { type: "button", onClick: () => {
                                return handleSave(false);
                            }, disabled: !hasUnsavedChanges || isSaving, className: `px-4 py-2 md:w-auto w-full font-semibold text-base rounded-md ${!hasUnsavedChanges
                                ? 'bg-blue-200 text-gray-400 cursor-not-allowed'
                                : 'bg-blue-600 text-white'}` }, isSaving ? React.createElement(Loader, { title: "Saving..." }) : 'Save')))),
            React.createElement("div", { role: "tabpanel", id: "email-details", className: `w-full py-2 md:px-6 px-4 flex flex-col items-start gap-6 ${activeTabIndex !== 1 ? 'hidden' : ''}` },
                React.createElement("div", { className: "w-full flex flex-col gap-4" },
                    React.createElement("div", { className: "w-full flex flex-col gap-2" },
                        React.createElement("h5", { className: "font-semibold text-gray-800 text-base" },
                            "User Status",
                            React.createElement(RequiredMark, null)),
                        React.createElement("div", { className: "w-full grid grid-cols-2 gap-4" }, userStatuses.map((status, index) => (React.createElement("label", { key: index, htmlFor: `status-${status}`, className: "text-gray-700 text-base flex items-center gap-2" },
                            React.createElement("input", { type: "checkbox", name: "userStatus", onChange: handleUserStatusChange, id: `status-${status}`, value: status, checked: checkedUserStatuses.includes(status), className: "bg-custom-checkbox bg-size-[100%_100%] bg-center bg-no-repeat shrink-0 appearance-none cursor-pointer w-5 h-5 rounded-sm border border-gray-400 bg-white checked:bg-blue-600 checked:border-transparent focus:outline-hidden" }),
                            t(`newsletterTemplates.userStatuses.${status}`)))))),
                    React.createElement("div", { className: "w-full flex flex-col gap-2" },
                        React.createElement("h5", { className: "font-semibold text-gray-800 text-base" },
                            "User Types",
                            React.createElement(RequiredMark, null)),
                        React.createElement("div", { className: "w-full grid grid-cols-2 gap-4" }, userTypes.map((type, index) => (React.createElement("label", { key: index, htmlFor: `type-${type}`, className: "text-gray-700 text-base flex items-center gap-2" },
                            React.createElement("input", { type: "checkbox", name: "userType", onChange: handleUserTypeChange, id: `type-${type}`, value: type, checked: checkedUserTypes.includes(type), className: "bg-custom-checkbox bg-size-[100%_100%] bg-center bg-no-repeat shrink-0 appearance-none cursor-pointer w-5 h-5 rounded-sm border border-gray-400 bg-white checked:bg-blue-600 checked:border-transparent focus:outline-hidden" }),
                            t(`newsletterTemplates.userTypes.${type}`)))))),
                    React.createElement("div", { className: "w-full flex flex-col gap-2" },
                        React.createElement("h5", { className: "font-semibold text-gray-800 text-base" }, "User Roles"),
                        React.createElement("div", { className: "w-full grid grid-cols-2 gap-4" }, userRoles.map((role, index) => (React.createElement("label", { key: index, htmlFor: `role-${role}`, className: "text-gray-700 text-base flex items-center gap-2" },
                            React.createElement("input", { type: "checkbox", name: "userRole", onChange: handleUserRoleChange, id: `role-${role}`, value: role, checked: checkedUserRoles.includes(role), className: "bg-custom-checkbox bg-size-[100%_100%] bg-center bg-no-repeat shrink-0 appearance-none cursor-pointer w-5 h-5 rounded-sm border border-gray-400 bg-white checked:bg-blue-600 checked:border-transparent focus:outline-hidden" }),
                            t(`newsletterTemplates.userRoles.${role}`)))))),
                    React.createElement("div", { className: "w-full grid md:grid-cols-2 grid-cols-1 gap-2" },
                        React.createElement("div", { className: "w-full flex flex-col gap-2" },
                            React.createElement("label", { htmlFor: "from-user-register-date", className: "font-semibold text-gray-800 text-base" }, "Registration date from"),
                            React.createElement("input", { type: "date", name: "from-user-register-date", id: "from-user-register-date", value: fromUserRegisterDate !== null && fromUserRegisterDate !== void 0 ? fromUserRegisterDate : '', className: "text-left p-3 border w-full border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal", onChange: (e) => {
                                    return setFromUserRegisterDate(e.target.value === '' ? null : e.target.value);
                                } })),
                        React.createElement("div", { className: "w-full flex flex-col gap-2" },
                            React.createElement("label", { htmlFor: "to-user-register-date", className: "font-semibold text-gray-800 text-base" }, "Registration date to"),
                            React.createElement("input", { type: "date", name: "to-user-register-date", id: "to-user-register-date", value: toUserRegisterDate !== null && toUserRegisterDate !== void 0 ? toUserRegisterDate : '', className: "text-left p-3 border w-full border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal", onChange: (e) => {
                                    return setToUserRegisterDate(e.target.value === '' ? null : e.target.value);
                                } }))),
                    React.createElement("div", { className: "w-full grid md:grid-cols-2 grid-cols-1 gap-2" },
                        React.createElement("div", { className: "w-full flex flex-col gap-2" },
                            React.createElement("label", { htmlFor: "from-email", className: "font-semibold text-gray-800 text-base" },
                                "From email address",
                                React.createElement(RequiredMark, null)),
                            React.createElement("input", { type: "email", name: "from-email", id: "from-email", required: true, className: "text-left p-3 border w-full border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal", value: fromEmailAddress, onChange: (e) => {
                                    return setFromEmailAddress(e.target.value);
                                } })),
                        React.createElement("div", { className: "w-full flex flex-col gap-2" },
                            React.createElement("label", { htmlFor: "from-name", className: "font-semibold text-gray-800 text-base" }, "From name"),
                            React.createElement("input", { type: "email", name: "from-name", id: "from-name", className: "text-left p-3 border w-full border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal", onChange: (e) => {
                                    return setFromName(e.target.value);
                                }, value: fromName }))),
                    React.createElement("div", { className: "w-full flex flex-col gap-2" },
                        React.createElement("label", { htmlFor: "replyto-email", className: "font-semibold text-gray-800 text-base" }, "Reply-to email (Optional)"),
                        React.createElement("input", { type: "email", name: "replyto-email", id: "replyto-email", className: "text-left p-3 border w-full border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal", onChange: handleReplyToEmailChange })),
                    React.createElement("div", { className: "w-full flex flex-col gap-2" },
                        React.createElement("label", { htmlFor: "recipient-ids", className: "flex flex-col gap-2 font-semibold text-gray-800 text-base" },
                            "Recipient IDs",
                            React.createElement("span", { className: "font-medium text-sm text-gray-700" },
                                "Enter recipient IDs separated by commas ( Your recipient Id:",
                                React.createElement("i", { className: "font-semibold text-gray-800 text-base" }, userId),
                                ")")),
                        React.createElement("input", { type: "text", name: "recipient-ids", id: "recipient-ids", className: "text-left p-3 border w-full border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal", onChange: handleRecipientIdUpdate }),
                        React.createElement("span", { className: "text-sm text-gray-700" }, "Only used by Simulate and Send test email. Send Now and Schedule Mailout are disabled while this field is filled in.")),
                    React.createElement("div", { className: "w-full flex flex-col gap-2" },
                        React.createElement("h5", { className: "font-semibold text-gray-800 text-base" },
                            "Select Network",
                            React.createElement(RequiredMark, null)),
                        React.createElement("div", { className: "w-full grid grid-cols-2 gap-4 max-h-96 overflow-auto" }, sites.map((site) => (React.createElement("label", { key: site.siteId, htmlFor: `site-${site.siteId}`, className: "text-gray-700 text-base flex items-center gap-2" },
                            React.createElement("input", { onChange: () => handleSiteChange(site), type: "radio", name: "siteId", required: true, id: `site-${site.siteId}`, value: site.siteId, className: "bg-custom-radio bg-size-[45%_45%] bg-center bg-no-repeat shrink-0 appearance-none cursor-pointer w-5 h-5 rounded-full border border-gray-400 bg-white checked:bg-blue-600 checked:border-transparent focus:outline-hidden" }),
                            site.siteName)))))),
                React.createElement("hr", { className: "w-full border-gray-400" }),
                React.createElement("div", { className: "w-full flex flex-col gap-4" },
                    React.createElement("h5", { className: "font-semibold text-gray-800 text-base" }, t('newsletterTemplates.scheduling.title')),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        React.createElement("label", { className: "text-gray-700 text-base flex items-center gap-2" },
                            React.createElement("input", { type: "radio", name: "sendTiming", checked: sendImmediately, onChange: () => setSendImmediately(true), className: "bg-custom-radio bg-size-[45%_45%] bg-center bg-no-repeat shrink-0 appearance-none cursor-pointer w-5 h-5 rounded-full border border-gray-400 bg-white checked:bg-blue-600 checked:border-transparent focus:outline-hidden" }),
                            t('newsletterTemplates.scheduling.sendImmediately'))),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        React.createElement("label", { className: "text-gray-700 text-base flex items-center gap-2" },
                            React.createElement("input", { type: "radio", name: "sendTiming", checked: !sendImmediately, onChange: () => setSendImmediately(false), className: "bg-custom-radio bg-size-[45%_45%] bg-center bg-no-repeat shrink-0 appearance-none cursor-pointer w-5 h-5 rounded-full border border-gray-400 bg-white checked:bg-blue-600 checked:border-transparent focus:outline-hidden" }),
                            t('newsletterTemplates.scheduling.scheduleForLater'))),
                    !sendImmediately && (React.createElement("div", { className: "ml-7 flex flex-col gap-2" },
                        React.createElement("label", { className: "text-gray-700 text-sm" }, "Scheduled Send Date (GMT)"),
                        React.createElement("input", { type: "date", value: scheduledDate, onChange: (e) => setScheduledDate(e.target.value), className: "text-left p-3 border w-full md:w-1/2 border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal", min: new Date().toISOString().split('T')[0] }),
                        React.createElement("label", { className: "text-gray-700 text-sm mt-2" }, "Scheduled Send Time (GMT)"),
                        React.createElement("div", { className: "flex gap-2 w-full md:w-1/2" },
                            React.createElement("select", { value: scheduledHour, onChange: (e) => setScheduledHour(e.target.value), className: "flex-1 p-3 border border-gray-300 rounded-sm focus:outline-hidden focus:border-blue-500" }, Array.from({ length: 24 }, (_, i) => (React.createElement("option", { key: i, value: i.toString().padStart(2, '0') }, i.toString().padStart(2, '0'))))),
                            React.createElement("select", { value: scheduledMinute, onChange: (e) => setScheduledMinute(e.target.value), className: "flex-1 p-3 border border-gray-300 rounded-sm focus:outline-hidden focus:border-blue-500" },
                                React.createElement("option", { value: "00" }, "00"),
                                React.createElement("option", { value: "15" }, "15"),
                                React.createElement("option", { value: "30" }, "30"),
                                React.createElement("option", { value: "45" }, "45")))))),
                React.createElement("hr", { className: "w-full border-gray-400" }),
                React.createElement("div", { className: "w-full flex flex-col gap-4" },
                    React.createElement("h5", { className: "font-semibold text-gray-800 text-base" }, t('newsletterTemplates.scheduling.title')),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        React.createElement("label", { className: "text-gray-700 text-base flex items-center gap-2" },
                            React.createElement("input", { type: "radio", name: "sendTiming", checked: sendImmediately, onChange: () => setSendImmediately(true), className: "bg-custom-radio bg-size-[45%_45%] bg-center bg-no-repeat shrink-0 appearance-none cursor-pointer w-5 h-5 rounded-full border border-gray-400 bg-white checked:bg-blue-600 checked:border-transparent focus:outline-hidden" }),
                            t('newsletterTemplates.scheduling.sendImmediately'))),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        React.createElement("label", { className: "text-gray-700 text-base flex items-center gap-2" },
                            React.createElement("input", { type: "radio", name: "sendTiming", checked: !sendImmediately, onChange: () => setSendImmediately(false), className: "bg-custom-radio bg-size-[45%_45%] bg-center bg-no-repeat shrink-0 appearance-none cursor-pointer w-5 h-5 rounded-full border border-gray-400 bg-white checked:bg-blue-600 checked:border-transparent focus:outline-hidden" }),
                            t('newsletterTemplates.scheduling.scheduleForLater'))),
                    !sendImmediately && (React.createElement("div", { className: "ml-7 flex flex-col gap-2" },
                        React.createElement("label", { className: "text-gray-700 text-sm" }, "Scheduled Send Date (GMT)"),
                        React.createElement("input", { type: "date", value: scheduledDate, onChange: (e) => setScheduledDate(e.target.value), className: "text-left p-3 border w-full md:w-1/2 border-gray-300 placeholder-gray-200 rounded-sm focus:outline-hidden focus:border-blue-500 font-normal", min: new Date().toISOString().split('T')[0] }),
                        React.createElement("label", { className: "text-gray-700 text-sm mt-2" }, "Scheduled Send Time (GMT)"),
                        React.createElement("div", { className: "flex gap-2 w-full md:w-1/2" },
                            React.createElement("select", { value: scheduledHour, onChange: (e) => setScheduledHour(e.target.value), className: "flex-1 p-3 border border-gray-300 rounded-sm focus:outline-hidden focus:border-blue-500" }, Array.from({ length: 24 }, (_, i) => (React.createElement("option", { key: i, value: i.toString().padStart(2, '0') }, i.toString().padStart(2, '0'))))),
                            React.createElement("select", { value: scheduledMinute, onChange: (e) => setScheduledMinute(e.target.value), className: "flex-1 p-3 border border-gray-300 rounded-sm focus:outline-hidden focus:border-blue-500" },
                                React.createElement("option", { value: "00" }, "00"),
                                React.createElement("option", { value: "15" }, "15"),
                                React.createElement("option", { value: "30" }, "30"),
                                React.createElement("option", { value: "45" }, "45")))))),
                React.createElement("hr", { className: "w-full border-gray-400" }),
                React.createElement("div", { className: "w-full flex flex-wrap items-center gap-2" },
                    React.createElement("a", { href: previewBatchUrl.replace('BATCH_ID_PLACEHOLDER', (savedTemplateId === null || savedTemplateId === void 0 ? void 0 : savedTemplateId.toString()) || ''), target: "_blank", rel: "noreferrer", title: savedTemplateId
                            ? 'Preview the saved template'
                            : 'Save the template first to preview it', className: `px-4 py-2 md:w-auto w-full font-semibold text-base rounded-md ${savedTemplateId
                            ? 'bg-gray-200 text-gray-800'
                            : 'bg-gray-200 text-gray-400 cursor-not-allowed pointer-events-none'}` }, "Preview"),
                    React.createElement("button", { type: "button", onClick: sendTestEmail, disabled: isSendingTestEmail, className: "px-4 py-2 md:w-auto w-full bg-green-400 text-gray-800 font-semibold text-base rounded-md" }, isSendingTestEmail ? (React.createElement(Loader, { customColor: "text-gray-800", title: "Sending..." })) : ('Send test email')),
                    React.createElement("button", { type: "button", onClick: requestSendConfirmation, disabled: isPreparingSend || recipientIds.length > 0, title: recipientIds.length
                            ? 'Clear Recipient IDs to send or schedule the mailout'
                            : undefined, className: `px-4 py-2 md:w-auto w-full font-semibold text-base rounded-md ${recipientIds.length
                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                            : 'bg-blue-600 text-white'}` }, isPreparingSend ? (React.createElement(Loader, { title: "Counting recipients..." })) : sendImmediately ? ('Send Now') : ('Schedule Mailout')),
                    recipientIds.length > 0 && (React.createElement("p", { className: "w-full text-sm text-amber-700" },
                        sendImmediately ? 'Send Now' : 'Schedule Mailout',
                        " is disabled because Recipient IDs is filled in. Recipient IDs only limit Simulate and Send test email, never a live mailout. Clear the field to send."))),
                React.createElement("div", { className: "w-full flex flex-wrap items-center justify-between gap-2" },
                    React.createElement("button", { type: "button", onClick: simulateUsers, disabled: isSimulating, className: "px-4 py-2 md:w-auto w-full font-semibold text-base rounded-md bg-gray-200 text-gray-800" }, isSimulating ? (React.createElement(Loader, { customColor: "text-gray-800", title: "Simulating..." })) : ('Simulate no. of users')),
                    React.createElement("span", { className: "text-blue-600 text-2xl font-semibold" }, simulatedRecipients
                        ? `${simulatedRecipients.users} users + ${simulatedRecipients.newsletterSubscribers} subscribers`
                        : '0 users')))),
        sendConfirmation && (React.createElement(SendConfirmationModal, { templateTitle: template.title || template.subject, siteName: (_c = (_b = (_a = sites.find((site) => site.siteId === selectedSiteCode)) === null || _a === void 0 ? void 0 : _a.siteName) !== null && _b !== void 0 ? _b : selectedSiteCode) !== null && _c !== void 0 ? _c : '', recipients: sendConfirmation.recipients, scheduledSendAt: sendConfirmation.scheduledSendAt, isSending: isSending, onCancel: () => setSendConfirmation(null), onConfirm: () => createBatch(sendConfirmation.scheduledSendAt) }))));
};
export default AddNewsletterModal;
